<div class="container">
  <div class="mt-5 d-flex justify-content-center align-items-center flex-wrap flex-column">
    <h2>Pagina In Costruzione</h2>
    <button class="btn btn-primary" [routerLink]="['/home']">{{'notFound.goHome' | translate}}</button>
  </div>
</div>